import { Component, type ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface Props {
  children: ReactNode;
  resetKey?: string;
}

interface State {
  error: Error | null;
}

/** A failed lazy chunk or render stays inside this section. The rest of the shell stays usable. */
export class RouteErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidUpdate(previous: Readonly<Props>) {
    if (this.state.error && previous.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  private retry = () => this.setState({ error: null });

  render() {
    if (!this.state.error) return this.props.children;
    const diagnosticId = this.state.error.name || 'render-error';
    return (
      <div role="alert" className="m-4 rounded-card border border-line bg-surface p-5 text-ink">
        <h1 className="text-lg font-semibold">Раздел не открылся</h1>
        <p className="mt-2 text-sm">{this.state.error.message || 'Непредвиденная ошибка раздела'}</p>
        <p className="mt-2 text-xs text-muted">Код: {diagnosticId}</p>
        <p className="mt-2 text-xs text-muted">Черновики в этом браузере не стираются. Остальные разделы остаются доступны.</p>
        <div className="mt-4 flex flex-wrap gap-3">
          <button type="button" onClick={this.retry} className="min-h-11 rounded-lg bg-accent px-4 text-sm font-medium text-white">Повторить</button>
          <button type="button" onClick={() => window.location.reload()} className="min-h-11 rounded-lg border border-line px-4 text-sm">Перезагрузить приложение</button>
          <Link to="/" className="inline-flex min-h-11 items-center text-sm text-accent">На сегодня</Link>
        </div>
      </div>
    );
  }
}
